
import { Options, Vue } from "vue-class-component";
import { store } from "@/store";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import Paging from "@/components/Paging.vue";
import {
  alert_re_chinese,
  dateConversion,
  getLocalProject,
  regChineseObJ,
} from "@/utils";
import { readUserProfile } from "@/store/main/getters";
import {
  readMyProjects,
  readProjectSgameSkinList,
} from "@/store/project/getters";
import {
  dispatchCreateProjectScenes,
  dispatchDeleteProjectScene,
  dispatchGetProjectSgameSkinList,
  dispatchUpdateProjectScene,
  dispatchUpdateSgameSkin,
  dispatchDeleteSgameSkin,
  dispatchGetCreateProjectSgameSkinList,
} from "@/store/project/actions";

@Options({
  components: {
    SideMenu,
    Paging,
  },
})
export default class ProjectSceneManage extends Vue {
  public sceneForm = {
    id: "",
    original_scene_id: "",
    chinese: "",
    project: "",
  };
  public addCreate = {
    skinid: null,

    heroid: null,
    heroname: null,
    skin: null,
    skinname: null,
    desc: null,
    level: null,
  };
  public add = {
    skinid: null,

    heroid: null,
    heroname: null,
    skin: null,
    skinname: null,
    desc: null,
    level: null,
  };
  public size = 16; // 每页最大数
  public current_page = 1; // 当前页码
  public totalNum = 0;
  public i = 1;
  public search = "";
  public loading = false;
  public dialogVisible = false;
  public project = Number(getLocalProject());
  // 新增场景脚本
  public addSceneForm = {
    original_scene_id: "",
    chinese: "",
  };
  public open() {
    this.dialogVisible = true;
    this.add = JSON.parse(JSON.stringify(this.addCreate));
  }
  public name(i) {
    if (i == "skinid") {
      return "皮肤ID";
    }
    if (i == "heroid") {
      return "英雄ID";
    }
    if (i == "heroname") {
      return "英雄名";
    }
    if (i == "skin") {
      return "皮肤序号";
    }
    if (i == "skinname") {
      return "皮肤名";
    }
  }
  public async mounted() {
    this.loading = true;
    await dispatchGetProjectSgameSkinList(store, {
      project: this.project,
      size: this.size,
      page: this.current_page,
      search: this.search,
    });
    await this.onPaging(this.size, 1);
    this.loading = false;
  }

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.project
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  handleEdit(row: any, sceneForm: any) {
    if (!row.isEdit) {
      row.isEdit = !row.isEdit;
      row.handleEditText = "取消";
      row.info = "info";
      row.isDanger = "primary";
      row.handleDeleteText = "提交";
      row.handleConfirmText = "确认更改场景?";
    } else {
      row.isEdit = !row.isEdit;
      row.isDanger = "danger";
      row.info = "warning";
      row.handleEditText = "编辑";
      row.handleDeleteText = "删除";
      row.handleConfirmText = "确认删除场景?";
    }
  }
  public async edit() {
    let list = [];
    let indexList = ["skinid", "heroid", "heroname", "skin", "skinname"];
    indexList.forEach((v) => {
      if (!this.add[v]) {
        list.push(v);
      }
    });
    let str = "";
    if (list.length > 0) {
      list.forEach((i, index) => {
        str += this.name(i) + (index == list.length - 1 ? "" : ",");
      });
      alert(str + "不能为空");
      return;
    }
    this.dialogVisible = false;
    await dispatchGetCreateProjectSgameSkinList(store, {
      project: this.project,
      skinid: this.add.skinid,

      heroid: this.add.heroid,
      heroname: this.add.heroname,
      skin: this.add.skin,
      skinname: this.add.skinname,
      desc: this.add.desc,
      level: this.add.level,
    });
    this.onPaging(this.size, 1);
    this.i++;
  }
  //编辑, 删除
  public async handleDeleteScene(row) {
    await dispatchDeleteSgameSkin(store, {
      id: row.id,
      project: this.project,
    });
    this.onPaging(this.size, this.current_page);
  }
  public async handleEditScene(row: any) {
    let list = [];
    let indexList = ["id", "skinid", "heroid", "heroname", "skin", "skinname"];
    indexList.forEach((v) => {
      if (!row[v]) {
        list.push(v);
      }
    });
    let str = "";
    if (list.length > 0) {
      list.forEach((i, index) => {
        str += this.name(i) + (index == list.length - 1 ? "" : ",");
      });
      alert(str + "不能为空");
      return;
    }

    row.modify = false;
    dispatchUpdateSgameSkin(store, {
      project: this.project,
      id: row.id,
      skinid: row.skinid,
      heroid: row.heroid,
      heroname: row.heroname,
      skin: row.skin,
      skinname: row.skinname,
      desc: row.desc,
      level: row.level,
    });
  }

  public get project_scene_page() {
    return readProjectSgameSkinList(store);
  }

  getProjectScenes(search: string) {
    let scene_list: any[] = readProjectSgameSkinList(store).results;

    return scene_list;
  }

  public async submitForm() {
    let FormVal = {
      original_scene_id: this.addSceneForm.original_scene_id,
      chinese: this.addSceneForm.chinese,
      project: this.project,
    };
    this.dialogVisible = false;
    await dispatchCreateProjectScenes(store, FormVal);
    // await dispatchGetProjectSgameSkinList(store, {
    //   project: this.project,
    //      size: this.size,
    //   page: this.current_page,
    //   search: this.search,
    // });
    await this.onPaging(this.size, 1);
    this.i++;
  }

  // 分页
  public async onPaging(size: any, page: any) {
    this.loading = true;
    console.log(page);
    this.current_page = page;
    this.size = size;

    await dispatchGetProjectSgameSkinList(store, {
      project: this.project,
      size: this.size,
      page: this.current_page,
      search: this.search,
    });
    this.totalNum = this.project_scene_page.count;
    // this.i++
    this.loading = false;
  }

  // 查询
  public async onSearch() {
    this.loading = true;
    // await dispatchGetProjectSgameSkinList(store, {
    //   project: this.project,
    //   size: this.size,
    //   page: this.current_page,
    //   search: this.search,
    // });
    await this.onPaging(this.size, 1);
    this.loading = false;
  }
}
